
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import App from '../App';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const DreamCodePage = lazy(() => import('../pages/dream-code/page'));
const CaseStudiesPage = lazy(() => import('../pages/case-studies/page'));
const ImplementationPage = lazy(() => import('../pages/implementation/page'));
const AwardsPage = lazy(() => import('../pages/awards/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const LegalPage = lazy(() => import('../pages/legal/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/dream-code',
    element: <DreamCodePage />,
  },
  {
    path: '/cases',
    element: <CaseStudiesPage />,
  },
  {
    path: '/implementation',
    element: <ImplementationPage />,
  },
  {
    path: '/awards',
    element: <AwardsPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/legal',
    element: <LegalPage />,
  },
  {
    path: '/privacy',
    element: <NotFound />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
